"use strict";
exports.__esModule = true;
exports.isDOBValid = exports.DATE_LENGTH = void 0;
// US locale
// mm/dd/yyyy
var luxon_1 = require("luxon");
exports.DATE_LENGTH = 10;
var isOldEnough = function (date) {
    var monthFormat = date.split('/')[0].length > 1 ? 'MM' : 'M';
    var dayFormat = date.split('/')[1].length > 1 ? 'dd' : 'd';
    return luxon_1.DateTime.fromFormat(date, "".concat(monthFormat, "/").concat(dayFormat, "/yyyy")).diffNow('years').years <= -18;
};
var parseDate = function (date) {
    var _a = date.split('/').map(function (value) { return parseInt(value) || 0; }), month = _a[0], day = _a[1], year = _a[2];
    return luxon_1.DateTime.fromObject({ year: year, month: month, day: day });
};
var isDOBValid = function (dateStr) {
    var dobDate = parseDate(dateStr);
    var invalidYear = dobDate.year < 1900 || dobDate.year > 2100;
    if (!dobDate.isValid || invalidYear) {
        return false;
    }
    return isOldEnough(dateStr);
};
exports.isDOBValid = isDOBValid;
